/**
 * Ambient gradient wash behind every page: slowly drifting colour fields over a
 * faint dot grid. Purely decorative, so it is hidden from assistive tech and
 * never intercepts pointer events. Drift stops under prefers-reduced-motion.
 */
export function BackgroundGlow() {
  return (
    <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
      <div className="vox-grid absolute inset-x-0 top-0 h-[42rem] text-black/[0.07] dark:text-white/[0.06]" />
      <div className="vox-drift absolute -top-40 -left-32 h-[34rem] w-[34rem] rounded-full bg-cyan-500/20 blur-3xl dark:bg-cyan-500/15" />
      <div
        className="vox-drift absolute top-1/3 -right-40 h-[38rem] w-[38rem] rounded-full bg-purple-500/20 blur-3xl dark:bg-purple-500/15"
        style={{ animationDelay: '-9s' }}
      />
      <div
        className="vox-drift absolute -bottom-48 left-1/4 h-[32rem] w-[32rem] rounded-full bg-blue-500/20 blur-3xl dark:bg-blue-500/15"
        style={{ animationDelay: '-18s' }}
      />
    </div>
  )
}
